const standaloneAppDomainRegex = /^([a-z0-9]+)\.app\./i;

export function isStandaloneApp(host) {
  return standaloneAppDomainRegex.test(host);
}

export function getStandaloneAppId(host) {
  const match = host.match(standaloneAppDomainRegex);
  return match ? match[1] : null;
}
